// packages
import { h } from 'preact';
import * as d3 from 'd3';

import { customDateFormat, getStartEndDate } from '../utils/chart-utils';

// components
import PureComponent from './PureComponent';

class TimelineChart extends PureComponent {
  constructor() {
    super();

    this.getContainerWidth = this.getContainerWidth.bind(this);
    this.getNewProps = this.getNewProps.bind(this);
    this.createChart = this.createChart.bind(this);
    this.redrawChart = this.redrawChart.bind(this);
    this.getNewProps = this.getNewProps.bind(this);

    this.state = {
      width: null,
      height: null,
      bodyWidth: null,
      breakPoint: 544,
      section: 'bars_highlighted',
      part: 'all',
      type: 'weekly_bar_chart',
      scale: 'weekly_deaths_reported',
    };
  }

  createChart(week_data) {
    let {
      width,
      height,
      bodyWidth,
      breakPoint,
      section,
      part,
      type,
      scale,
    } = this.state;

    if (bodyWidth > breakPoint) height = 450;
    else height = 435;

    let colors = {
      bars_default: '#348094',
      bars_weekly: '#f3f3f3',
      bars_totals_statewide: '#f3f3f3',
      bars_totals: '#82c7d9',
    };



    let keys;
    let dateStart;

    // let dateStart = d3.min(week_data, d => d['date']);
    let dateEnd;

    dateStart = new Date('2020-03-18T00:00:00-05:00');

    dateEnd = getStartEndDate(week_data, 'last', 'Spring2021Chart', 'end_date');

    if (type == 'stacked_bars') {
      keys = Object.keys(week_data[0].deathWeeks[0])
        .slice(1)
        .filter(
          key => key == 'not_new_deaths' || key == 'weekly_deaths_reported'
        );
      keys = keys.reverse();
    }

    if (type == 'percent_stacked_bars') {
      keys = Object.keys(week_data[0].deathWeeks[0])
        .slice(1)
        .filter(
          key => key == 'pct_of_total_deaths' || key == 'pct_non_nursing_homes'
        );
    }

    // chart setup
    let margin = { top: 40, bottom: 25, right: 25, left: 33 };

    // adjust right margins on mobile

    width = width - margin.left - margin.right;
    height = height - margin.top - margin.bottom;


    let svg = d3
      .select(`.${section}.${part}`)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom);

    let g = svg
      .append('g')
      .attr('class', `bar-chart-chart-group`)
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // time scale

    let x = d3.scaleTime().domain([dateStart, dateEnd]).range([0, width]);

    // Find max scale
    let max_scale;

    if (Number.isInteger(scale)) max_scale = scale;
    else if (type == 'weekly_bar_chart')
      max_scale =
        d3.max(week_data[1].deathWeeks, d => d[scale]) + margin.bottom;
    else
      max_scale =
        d3.max(week_data[3].deathWeeks, d => d[scale]) + margin.bottom;

    // number scale

    let y = d3.scaleLinear().domain([0, max_scale]).nice().range([height, 0]);

    let xAxis = g =>
      g
        .call(
          d3
            .axisBottom(x)
            .ticks(15)
            .tickFormat((d, i) => {
              return bodyWidth < breakPoint
                ? customDateFormat(d, i, 3, { includeYear: true })
                : customDateFormat(d, i, 1, { includeYear: true });
            })
        )
        .attr('transform', `translate(0,${height})`)
        .attr('class', 'axis axis--x');

    let yAxis = g =>
      g
        .attr('transform', `translate(0,0)`)
        .call(
          d3.axisLeft(y).ticks(5).tickSize(-width).tickFormat(customYFormat)
        )
        .attr('class', 'axis axis--y');

    g.append('g').call(xAxis);
    g.append('g').call(yAxis);

    if (type == 'stacked_bars' || type == 'percent_stacked_bars') {
      week_data.forEach(section_data => {
        let deathWeeks = section_data.deathWeeks;

        let sectionName = section_data.sectionName;

        let stackedDataBreakdown = d3.stack().keys(keys)(deathWeeks);

        let fill = `M${x(d3.min(deathWeeks, d => d['date'])) - 0.7},${height}`,
          fill2 = `M${x(d3.min(deathWeeks, d => d['date'])) - 0.7},${height}`;

        stackedDataBreakdown.forEach((each_data, index) => {
          each_data.forEach((d, i) => {
            let x0 = x(d.data.end_date);

            if (index == 0) {
              let y0 = y(d[1]);

              fill += `V${y0}H${x0}`;
            }
            if (index == 1) {
              let y0 = y(d[1]);

              fill2 += `V${y0}H${x0}`;
            }
          });
        });
        fill2 += `V${height}Z`;

        fill += `V${height}Z`; // this is bottom

        const top_fill = g
          .append('path')
          .attr('class', `path-fill ${sectionName}`)
          .attr('d', fill2);

        if (type == 'stacked_bars')
          top_fill.style('fill', colors['bars_default']);
        else top_fill.style('fill', colors['bars_totals_statewide']);

       const bottom_fill =  g.append('path')
          .attr('class', 'path-fill bottom-section')
          .attr('d', fill);

   if (type == 'stacked_bars')
          bottom_fill.style('fill', colors['bars_totals']);
        else bottom_fill.style('fill', colors['bars_default']);
      });
    }

    if (type == 'weekly_bar_chart') {
      // start out line and fill variables for step chart
      week_data.forEach(section_data => {
        let sectionName = section_data.sectionName;
        let deathWeeks = section_data.deathWeeks;

        let fill = `M${x(d3.min(deathWeeks, d => d['date'])) - 0.7},${height}`;

        deathWeeks.forEach((d, i) => {
          let y0 = y(d[scale]),
            x0 = x(d.end_date);
          fill += `V${y0}H${x0}`;
        });

        fill += `V${height}Z`;

        const step_chart_path = g
          .append('path')
          .attr('class', `path-fill ${sectionName}`)
          .attr('d', fill);

        if (part == sectionName || part == 'all')
          step_chart_path.style('fill', colors['bars_default']);
        else step_chart_path.style('fill', '#f0f0f0');
      });
    }

    function customYFormat(d) {
      if (d === 0) return '';
      else if (type == 'percent_stacked_bars') return d + '%';
      else return d3.format(',')(d);
    }
  }

  redrawChart() {
    const { week_data } = this.props;

    let { width, bodyWidth } = this.getContainerWidth();
    let { section, part, type, scale } = this.getNewProps();
    d3.selectAll(`.${section}.${part} svg`).remove();

    this.setState({
      width: width,
      bodyWidth: bodyWidth,
      section: section,
      part: part,
      type: type,
      scale: scale,
    });
    this.createChart(week_data);
  }

  getContainerWidth() {
    let base;

    base = d3.select('.chart-container');

    const body = d3.select('body');

    const width = base.node().offsetWidth;
    const bodyWidth = body.node().offsetWidth;

    return { width, bodyWidth };
  }

  getNewProps() {
    let chart = document.querySelector('.timeline-chart');

    const classes = chart.className.split(' ');

    const section = classes[1];

    const part = classes[2];

    const type = classes[3];

    let scale;

    if (type == 'stacked_bars') scale = 'deaths_nursing_homes';
    if (type == 'percent_stacked_bars') scale = 100;
    if (type == 'weekly_bar_chart') scale = 'weekly_deaths_reported';

    return { section, part, type, scale };
  }

  componentDidMount() {
    const { week_data } = this.props;
    let { width, bodyWidth } = this.getContainerWidth();
    let { section, part, type, scale } = this.getNewProps();

    this.setState(
      {
        width: width,
        bodyWidth: bodyWidth,
        section: section,
        part: part,
        type: type,
        scale: scale,
      },
      () => {
        this.createChart(week_data);
      }
    );

    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  componentWillUnmount() {
    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  render() {
    const { section, part, type } = this.state;

    return <div class={`timeline-chart ${section} ${part} ${type}`}></div>;
  }
}

export default TimelineChart;
